import { Button, Layout, Row, Space, Typography } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import VerifiedIcon from "../../../assets/icons/verify.svg";
import EarthImg from "../../../assets/images/earth.webp";
import PublicAuthentificationModalComponent from "../../../components/PublicAuthentificationModalComponent";
import useFetchPublicEvent from "../../../hooks/liveHooks/useFetchPublicEvent";
import liveUtil from "../../../utls/LiveUtil";
import "./index.less";

const PublicFanEventPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { event: live } = useFetchPublicEvent(id!);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const hideModal = () => {
    setIsModalVisible(false);
  };

  return (
    <Layout className={`${isModalVisible ? "no-scroll-page" : ""}`}>
      <Layout.Content className="content fanEventContentWrapper gradient-background-black no-scroll-horizontal">
        <div
          className="eventHeaderImg"
          style={{
            backgroundImage: `url(${live?.scheduleData?.media && typeof live?.scheduleData?.media === "object" ? live?.scheduleData?.media?.absolutePath : ""})`,
          }}
          onClick={showModal}
        >
          <div className="w-full eventHeaderUserInfo">
            <Typography.Text className="fullname">{live?.creator?.username}</Typography.Text>
            {live?.scheduleData?.message && <Typography.Text className="descriptionEvent">{live?.scheduleData?.message}</Typography.Text>}
          </div>
        </div>
        <Row className="mainContent mt-16">
          <Row className="rowVerified">
            <img src={VerifiedIcon} width={14} alt="premium" />
            <Typography.Text className="font-12-bold text-white-color">{t("verified-artist-upp")}</Typography.Text>
          </Row>
          <Row className="titleEvent">{t("exclusive-live-show")}</Row>
          <Row className="timeInfo">
            <div className="divTimeInfo">
              {live?.scheduleData?.dateTime && (
                <Typography.Text className="timeText">{liveUtil.getScheduleDateTime(t, live.scheduleData.dateTime)}</Typography.Text>
              )}
            </div>
          </Row>
          <Space className="w-full" direction="vertical">
            <Row className="w-full">
              <Button className="reserveButton" onClick={showModal}>
                {t("get-a-ticket")}
              </Button>
            </Row>
          </Space>
          <Row className="row-img">
            <img src={EarthImg} alt="earth" />
          </Row>
        </Row>
      </Layout.Content>
      <PublicAuthentificationModalComponent avatar={live?.creator?.avatar} name={live?.creator?.name} visible={isModalVisible} onClose={hideModal} />
    </Layout>
  );
};

export default PublicFanEventPage;
